import React from 'react';
import './Policy.css';

const Policy = ({ title, content }) => {
  return (
    <div className="policy-main-container">
      <div className="policy-content-wrapper">
        <div className="policy-content">
          <h1 className="policy-title">{title}</h1>
          <div className="policy-text">
            {content.map((item, index) => (
              <div key={index} className="policy-point">
                <p>{item}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Policy;
